<template>
    <div>
         <!-- 左按钮 -->
        <button class="switch-btn left-btn" @click="prev" :disabled="mainProjectIndex === 0" v-if="mainProjects.length>1">
            ←
        </button>
        <!-- 右按钮 -->
        <button class="switch-btn right-btn" @click="next" :disabled="mainProjectIndex === mainProjects.length - 1" v-if="mainProjects.length>1">
            →
        </button>

        <!-- 美光 -->
        <div class="content" v-if="mainProjectIndex==0">
            <div class="title">
                <div class="icon"> </div>
                <h1>美光半导体（西安）FMCS系统</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-right">
                    美光半导体（西安）有限责任公司是美光科技在西安高新区设立的外商独资企业，主要从事集成电路封装测试和内存模块制造，是陕西省最大的外商投资项目之一，其进出口额曾连续七年位居全省首位。</p>
                <img src="../../../../../assets/img/case/bandaoti/bandaoti_meiguang.png"></img>
            </div> -->
            <p><img src="../../../../../assets/img/case/bandaoti/bandaoti_meiguang.png" class="company-img"></img></p>
            <p>
                本项目内容包括厂务设施管理控制系统（FMCS）和能源管理系统（EMS）两大部分。
            </p>
            <p>FMCS 负责对空调机组、制冷系统、工艺冷冻水、空压系统、锅炉系统、特气系统、纯水系统、废水系统等进行集中监控，并集成各控制子系统，实现统一管理，保障生产环境稳定与设备高效运行。
</p>
<p>EMS 在 FMCS 架构基础上，实现能源过程的监控、统计分析、信息管理、计划调度、稳态供应及计量器具管理等功能，为公司节能降耗提供数据支持。</p>
<p>我们承担了美光西安四期、五期新建厂房的控制系统建设任务，以及多项早期FMCS系统升级改造工作。</p>
        </div>

        <!-- 聚瑞芯光电项目 -->
        <div class="content" v-if="mainProjectIndex==1">
            <div class="title">
                <div class="icon"> </div>
                <h1>聚瑞芯光电项目</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-left">
                    聚瑞芯光电有限公司位于宝鸡市姜谭西路7号，占地面积88亩，是中西部规模最大的新材料半导体产业基地之一。公司深耕于新材料半导体晶圆外延、光电子元器件及高端芯片封装的研发、制造与销售领域。公司汇聚了全球顶尖的技术人才，并掌握大量国内外前沿专利，构筑了坚实的核心技术壁垒。</p>
                <img src="../../../../../assets/img/case/bandaoti/bandaoti_juruixing.png"></img>
            </div> -->
            <p><img src="../../../../../assets/img/case/bandaoti/bandaoti_juruixing.png" class="company-img"></img></p>
            <p>
               本项目范围包括FMCS（厂务监控系统）与弱电系统的深化设计、设备采购、安装集成与调试交付，以及后续的售后服务。项目将对净化空调系统（含MAU、FFU、DCC）、工艺排风系统、冷热源系统（含低温及中温冷冻水、热水系统）、洁净介质系统（如压缩空气、工艺冷却水、特气系统）、以及给排水系统（含纯水与废水系统）等关键子系统实施全面的自动化监控，确保实现集中、高效的智能化管理。</p>
               <p style="text-align: center;">
                <img src="../../../../../assets//img/case/bandaoti/bandaoti_juruixing_1.png" style="width:60%"></img></p>
               <p>旨在构建一个高效、稳定且智能的一体化厂务监控与管理体系，为企业的安全生产与高效运营奠定坚实的技术基础。</p>
        </div>

        <!-- 临空智慧云港项目 -->
        <div class="content" v-if="mainProjectIndex==2">
            <div class="title">
                <div class="icon"> </div>
                <h1>临空智慧云港项目</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-right" style="margin-top:4em;width:20em;">
                    临空智慧云港项目位于空港新城核心区域，园区规划用地面积约157.62亩，总建筑面积达15.22万平方米。一期已建成面积7.55万平方米，涵盖综合办公楼、设计办公楼、生产厂房、餐饮宿舍楼等多元功能空间，为企业提供包括高标准研发生产场地、办公空间、人才公寓、会议中心及餐饮服务在内的全方位、高品质配套设施。</p>
                <img src="../../../../../assets/img/case/bandaoti/baodaoti_zhihuiyungang.png"></img>
            </div> -->
            <p><img src="../../../../../assets/img/case/bandaoti/baodaoti_zhihuiyungang.png" class="company-img"></img></p>
            <p></p>
            <p>
               本项目合作内容涵盖园区自动化控制工程及FMCS（厂务监控系统）的软硬件全流程深化设计与改造。通过部署WinCC自动控制软件，实现了对实时数据与历史数据的系统集成与统一管理，并结合三维可视化技术，直观动态地呈现园区设施设备的运行状态。系统有效整合了多类自动化与信息化软硬件资源，运行稳定高效，具备可靠的联锁报警机制、流畅的冗余切换能力以及完整的历史数据追溯功能，相关技术文档齐全规范。项目的实施显著提升了园区的智能化管理水平和整体运营效率。</p>
        </div>

        <!-- 先导院 -->
        <div class="content" v-if="mainProjectIndex==3">
            <div class="title">
                <div class="icon"> </div>
                <h1>陕西光电子先导院先进硅光集成技术平台项目</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-left" style="margin-top:3em;width:23em;">
                    陕西光电子先导院科技有限公司是中科院西安光机所联合高新区、科技厅于2015年共同发起设立的技术服务平台公司，创新打造公共平台+技术服务的运营模式。公司拥有8000平方米涵盖百级至十万级的洁净厂房资源，为推动我国光电子产业快速发展、实现高水平科技自立自强作出重要贡献，获得产业界、学术界及国家部委的高度认可，并被授予国家级专业共性技术平台、双创平台，以及陕西省光子产业链“链主”单位等多项重要资质。</p>
                <img src="../../../../../assets/img/case/bandaoti/bandaoti_xiandaoyuan.png"></img>                
            </div> -->
            <p><img src="../../../../../assets/img/case/bandaoti/bandaoti_xiandaoyuan.png" class="company-img"></img></p>
            <p>
               本项目在基础设施智能化方面采用西门子先进的TIA博图软件平台，配合PROFINET工业网络协议，构建高效稳定的工业自动化环境。系统网络采用管理层与控制层分层设计，实现集中监控与数据管理，保障生产流程顺畅运行。</p>
               <p>除暖通自控系统外，项目还实现了对空压机、氮气系统、有机废气处理、PCW系统、真空系统及纯水系统等多个关键子系统的集中控制与智能联动，为生产运营提供全面、稳定、可靠的基础设施保障，助力企业高效运行与持续创新。</p>
        </div>

                
        <foot-img-carousel type="bandaoti" :projects="otherProjects" @change="showProjectDetail"></foot-img-carousel>
    </div>
</template>

<script>
import footImgCarousel from './footImgCarousel.vue';
export default {
    components: {
        footImgCarousel
    },
    data(){
        return {
            mainProjectIndex: 0,
            mainProjects: [{
                    cover: "meiguang",
                    title: "美光半导体（西安）FMCS系统",
                    hasDetail: true
                },
                {
                    cover: "juruixing",
                    title: "聚瑞芯光电项目",
                    hasDetail: true
                },
                {
                    cover: "zhihuiyungang",
                    title: "临空智慧云港项目",
                    hasDetail: true
                },
                {
                    cover: "xiandaoyuan",
                    title: "陕西光电子先导院先进硅光集成技术平台项目",
                    hasDetail: true
                }
            ],
            otherProjects:[]
        }
    },
  methods: {
      showProjectDetail(index) {
          this.mainProjectIndex = index
      },
      prev() {
          if (this.mainProjectIndex > 0) this.mainProjectIndex--;
      },
      next() {
          if (this.mainProjectIndex < this.mainProjects.length - 1) this.mainProjectIndex++;
      }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/case.less';
</style>